import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from 'src/app/common/store/generic.reducer';
import { GenericState, IState } from 'src/app/common/store/types';
import { contractActions } from './contract.actions';
import {
  CarInsuranceContractModel,
  ContractModel,
  ContractStatusFlow,
  ContractStatusHistoryModel,
  CreateContractFormModel,
  HealthInsuranceContractDetailModel,
  HouseInsuranceContractModel,
} from './types';

export interface IContractState extends IState<ContractModel> {
  getByLeadId: GenericState<ContractModel>;
  getById: GenericState<ContractModel>;
  getByUniqueId: GenericState<ContractModel>;
  getHealthDetail: GenericState<HealthInsuranceContractDetailModel[]>;
  getCarDetail: GenericState<CarInsuranceContractModel>;
  getHouseDetail: GenericState<HouseInsuranceContractModel>;
  getStatusFlow: GenericState<ContractStatusFlow[]>;
  getStatusActions: GenericState<any[]>;
  getContractModel: GenericState<CreateContractFormModel>;
  getHealthContractModel: GenericState<HealthInsuranceContractDetailModel[]>;
  getCarContractModel: GenericState<CarInsuranceContractModel>;
  getHouseContractModel: GenericState<HouseInsuranceContractModel>;
  createContract: GenericState<any>;
  createHealthContract: GenericState<any>;
  createCarContract: GenericState<any>;
  createHouseContract: GenericState<any>;
  updateContract: GenericState<ContractModel>;
  updateHealthContract: GenericState<ContractModel>;
  updateCarContract: GenericState<ContractModel>;
  updateHouseContract: GenericState<ContractModel>;
  getIfDataReadOnlyFromContractId: GenericState<boolean>;
  getContractStatusHistory: GenericState<ContractStatusHistoryModel>;
  updateContractStatusHistory: GenericState<ContractStatusHistoryModel>;
  deleteContractStatusHistory: GenericState<boolean>;
}

export const contractInitialState: IContractState = {
  getByLeadId: new GenericState<ContractModel>(),
  getById: new GenericState<ContractModel>(),
  getByUniqueId: new GenericState<ContractModel>(),
  getHealthDetail: new GenericState<HealthInsuranceContractDetailModel[]>(),
  getCarDetail: new GenericState<CarInsuranceContractModel>(),
  getHouseDetail: new GenericState<HouseInsuranceContractModel>(),
  getStatusFlow: new GenericState<ContractStatusFlow[]>(),
  getStatusActions: new GenericState<any[]>(),
  getContractModel: new GenericState<CreateContractFormModel>(),
  getHealthContractModel: new GenericState<
    HealthInsuranceContractDetailModel[]
  >(),
  getCarContractModel: new GenericState<CarInsuranceContractModel>(),
  getHouseContractModel: new GenericState<HouseInsuranceContractModel>(),
  createContract: new GenericState<any>(),
  createHealthContract: new GenericState<any>(),
  createCarContract: new GenericState<any>(),
  createHouseContract: new GenericState<any>(),
  updateContract: new GenericState<ContractModel>(),
  updateHealthContract: new GenericState<ContractModel>(),
  updateCarContract: new GenericState<ContractModel>(),
  updateHouseContract: new GenericState<ContractModel>(),
  getIfDataReadOnlyFromContractId: new GenericState<boolean>(),
  getContractStatusHistory: new GenericState<ContractStatusHistoryModel>(),
  updateContractStatusHistory: new GenericState<ContractStatusHistoryModel>(),
  deleteContractStatusHistory: new GenericState<boolean>(),
};

const contractReducers = [
  ...onApiCall<ContractModel>(contractActions.getByLeadId, 'getByLeadId'),
  ...onApiCall<ContractModel>(contractActions.getById, 'getById'),
  ...onApiCall<ContractModel>(contractActions.getByUniqueId, 'getByUniqueId'),
  ...onApiCall<HealthInsuranceContractDetailModel[]>(
    contractActions.getHealthDetail,
    'getHealthDetail',
  ),
  ...onApiCall<CarInsuranceContractModel>(
    contractActions.getCarDetail,
    'getCarDetail',
  ),
  ...onApiCall<HouseInsuranceContractModel>(
    contractActions.getHouseDetail,
    'getHouseDetail',
  ),
  ...onApiCall<ContractStatusFlow[]>(
    contractActions.getStatusFlow,
    'getStatusFlow',
  ),
  ...onApiCall<any[]>(contractActions.getStatusActions, 'getStatusActions'),
  ...onApiCall<ContractModel>(
    contractActions.getContractModel,
    'getContractModel',
  ),
  ...onApiCall<HealthInsuranceContractDetailModel[]>(
    contractActions.getHealthContractModel,
    'getHealthContractModel',
  ),
  ...onApiCall<CarInsuranceContractModel>(
    contractActions.getCarContractModel,
    'getCarContractModel',
  ),
  ...onApiCall<HouseInsuranceContractModel>(
    contractActions.getHouseContractModel,
    'getHouseContractModel',
  ),
  ...onApiCall<string>(contractActions.createContract, 'createContract'),
  ...onApiCall<string>(
    contractActions.createHealthContract,
    'createHealthContract',
  ),
  ...onApiCall<string>(contractActions.createCarContract, 'createCarContract'),
  ...onApiCall<string>(
    contractActions.createHouseContract,
    'createHouseContract',
  ),
  ...onApiCall<string>(contractActions.updateContract, 'updateContract'),
  ...onApiCall<string>(
    contractActions.updateHealthContract,
    'updateHealthContract',
  ),
  ...onApiCall<string>(contractActions.updateCarContract, 'updateCarContract'),
  ...onApiCall<string>(
    contractActions.updateHouseContract,
    'updateHouseContract',
  ),
  ...onApiCall<boolean>(
    contractActions.getIfDataReadOnlyFromContractId,
    'getIfDataReadOnlyFromContractId',
  ),
  ...onApiCall<ContractStatusHistoryModel>(
    contractActions.getContractStatusHistory,
    'getContractStatusHistory',
  ),
  ...onApiCall<ContractStatusHistoryModel>(
    contractActions.updateContractStatusHistory,
    'updateContractStatusHistory',
  ),
  ...onApiCall<boolean>(
    contractActions.deleteContractStatusHistory,
    'deleteContractStatusHistory',
  ),
];

export const contractReducer = createReducer(
  contractInitialState,
  ...contractReducers,
) as ActionReducer<IContractState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return contractReducer(state, action);
}
